import React, { useState } from 'react';

const SERVERS = {
  PROD: "https://api.turnaments.com",
  TEST: "http://localhost"
};

const LANGUAGES = {
  tr: "tr",
  en: "en",
  pl: "pl"
};

export default function ServerSelector() {
  // Sunucu state'i
  const [currentServer, setCurrentServer] = useState(
    localStorage.getItem("selected_server") || SERVERS.PROD
  );

  // Dil state'i (Varsayılan olarak Türkçe 'tr' ayarlı)
  const [currentLang, setCurrentLang] = useState(
    localStorage.getItem("app_lang") || LANGUAGES.tr
  );

  // Sunucu değiştiğinde
  const handleServerChange = (e) => {
    const newServer = e.target.value;
    localStorage.setItem("selected_server", newServer);
    window.location.reload(); 
  };

  // Dil değiştiğinde
  const handleLanguageChange = (e) => {
    const newLang = e.target.value;
    localStorage.setItem("app_lang", newLang);
    window.location.reload(); // Axios interceptor'ın yeni dili hemen alması ve sayfanın yenilenmesi için
  };

  return (
    <div style={styles.container}>
      {/* Sunucu Seçimi */}
      <div style={styles.group}>
        <label style={styles.label}>Aktif Sunucu: </label>
        <select 
          value={currentServer} 
          onChange={handleServerChange}
          style={styles.select}
        >
          <option value={SERVERS.PROD}>Canlı Sunucu (Live)</option>
          <option value={SERVERS.TEST}>Test Sunucusu</option>
        </select>
      </div>

      {/* Dil Seçimi */}
      <div style={styles.group}>
        <label style={styles.label}>Dil (Language): </label>
        <select 
          value={currentLang} 
          onChange={handleLanguageChange}
          style={styles.select}
        >
          <option value={LANGUAGES.tr}>Türkçe</option>
          <option value={LANGUAGES.en}>English</option>
          <option value={LANGUAGES.pl}>Polski</option>
        </select>
      </div>
    </div>
  );
}

// Stilleri daha temiz durması ve yan yana hizalanması için güncelledik
const styles = {
  container: {
    display: 'flex',          // Elemanları yan yana dizer
    alignItems: 'center',
    gap: '24px',              // Sunucu ve Dil blokları arasında boşluk bırakır
    padding: '12px 20px',
    backgroundColor: '#18181b', // Çok koyu şık bir siyah/gri
    borderBottom: '1px solid #27272a', // İnce bir ayırıcı çizgi
    color: '#e4e4e7',
    flexWrap: 'wrap',         // Küçük ekranlarda (mobilde) alt alta geçmeyi sağlar
  },
  group: {
    display: 'flex',
    alignItems: 'center',
    
  },
  label: {
    marginRight: '10px',
    fontSize: '14px',
    fontWeight: '500',
    color: '#a1a1aa',         // Etiketlerin rengini hafif yumuşattık (şık görünüm için)
  },
  select: {
    backgroundColor: '#27272a', // Menünün kendi arka planı
    color: '#ffffff',           // Menü içi yazı rengi
    border: '1px solid #3f3f46', // İnce şık bir kenarlık
    borderRadius: '6px',
    padding: '8px 12px',
    fontSize: '14px',
    cursor: 'pointer',
    outline: 'none',            // Tıklayınca çıkan mavi çizgiyi kaldırır
    boxShadow: '0 2px 4px rgba(0,0,0,0.2)', // Hafif bir derinlik
    transition: 'border-color 0.2s ease', // Hover/Focus animasyonu
  }
};